module.exports = __webpack_public_path__ + "img/logocyd1.57e89365.png";